const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  isLogin: state => state.user.isLogin
}

export default getters
